import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  roles: [],
  roleDetails: {},
  isLoading: false,
  error: null,
};

export const getRoles: any = createAsyncThunk(
  "content/getRoles",
  async (params) => {
    const res = await axios.get(`/slpapp/Role/getall`, {
      params: params,
    });
    const data = await res.data;
    return data;
  }
);

export const savePermissionForRole: any = createAsyncThunk(
  "content/savePermissionForRole",
  async (body) => {
    const res = await axios.post(
      `/slpapp/RoleToMapping/savePermissionForRole`,
      body
    );
    const data = await res.data;

    return data;
  }
);

export const getRoleById: any = createAsyncThunk(
  "content/geRoleById",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/Role/roleById`, {
      params: { roleId: id },
    });
    const data = await res?.data?.data;
    return data;
  }
);

export const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRoles.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getRoles.fulfilled, (state, action) => {
      state.isLoading = false;
      state.roles = action.payload;
    });
    builder.addCase(getRoles.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(getRoleById.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getRoleById.fulfilled, (state, action) => {
      state.isLoading = false;
      state.roleDetails = action.payload;
    });
    builder.addCase(getRoleById.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(savePermissionForRole.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(savePermissionForRole.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(savePermissionForRole.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});

export default roleSlice.reducer;
